(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(8)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var stickSize = 8;
var styleMapping = {
  y: {
    t: 'top',
    m: 'marginTop',
    b: 'bottom'
  },
  x: {
    l: 'left',
    m: 'marginLeft',
    r: 'right'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-drag-resize-rotate',
  emits: ['rotating', 'rotatestop', 'resizing', 'resizestop', 'dragging', 'dragstop', 'clicked', 'activated', 'deactivated'],
  props: {
    deg: {
      type: Number,
      default: 0
    },
    item: {},
    parentScaleX: {
      type: Number,
      default: 1
    },
    parentScaleY: {
      type: Number,
      default: 1
    },
    isActive: {
      type: Boolean,
      default: false
    },
    preventActiveBehavior: {
      type: Boolean,
      default: false
    },
    isRotatable: {
      type: Boolean,
      default: true
    },
    isDraggable: {
      type: Boolean,
      default: true
    },
    isResizable: {
      type: Boolean,
      default: true
    },
    aspectRatio: {
      type: Boolean,
      default: false
    },
    parentLimitation: {
      type: Boolean,
      default: false
    },
    parentW: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val >= 0;
      }
    },
    parentH: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val >= 0;
      }
    },
    w: {
      type: Number,
      default: 100,
      validator: function validator(val) {
        return val > 0;
      }
    },
    h: {
      type: Number,
      default: 30,
      validator: function validator(val) {
        return val > 0;
      }
    },
    minw: {
      type: Number,
      default: 50,
      validator: function validator(val) {
        return val > 0;
      }
    },
    minh: {
      type: Number,
      default: 10,
      validator: function validator(val) {
        return val > 0;
      }
    },
    x: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return typeof val === 'number';
      }
    },
    y: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return typeof val === 'number';
      }
    },
    z: {
      type: [String, Number],
      default: 'auto',
      validator: function validator(val) {
        var valid = typeof val === 'string' ? val === 'auto' : val >= 0;
        return valid;
      }
    },
    dragHandle: {
      type: String,
      default: null
    },
    dragCancel: {
      type: String,
      default: null
    },
    sticks: {
      type: Array,
      default: function _default() {
        return ['tl', 'tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml'];
      }
    },
    aspectRatioSticks: {
      type: Array,
      default: function _default() {
        return ['tl', 'tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml'];
      }
    },
    axis: {
      type: String,
      default: 'both',
      validator: function validator(val) {
        return ['x', 'y', 'both', 'none'].indexOf(val) !== -1;
      }
    },
    snapToGrid: {
      type: Boolean,
      default: false
    },
    gridX: {
      type: Number,
      default: 50,
      validator: function validator(val) {
        return val > 0;
      }
    },
    gridY: {
      type: Number,
      default: 50,
      validator: function validator(val) {
        return val > 0;
      }
    },
    type: {}
  },
  data: function data() {
    return {
      rawDeg: this.deg,
      rotateCenter: [],
      rotateEnd: [],
      rotateStart: [],
      active: this.isActive,
      rawWidth: this.w,
      rawHeight: this.h,
      rawLeft: this.x,
      rawTop: this.y,
      rawRight: null,
      rawBottom: null,
      zIndex: this.z,
      parentWidth: null,
      parentHeight: null,
      left: this.x,
      top: this.y,
      right: null,
      bottom: null,
      minWidth: this.minw,
      minHeight: this.minh,
      currentFixArray: [],
      currentFixSpot: [],
      ratioStick: null,
      finalFixArray: []
    };
  },
  created: function created() {
    this.stickDrag = false;
    this.bodyDrag = false;
    this.rotateDrag = false;
    this.stickAxis = null;
    this.stickStartPos = { mouseX: 0, mouseY: 0, x: 0, y: 0, w: 0, h: 0 };
    this.limits = {
      minLeft: null,
      maxLeft: null,
      minRight: null,
      maxRight: null,
      minTop: null,
      maxTop: null,
      minBottom: null,
      maxBottom: null
    };
    this.currentStick = [];
  },
  mounted: function mounted() {
    this.cacuFather();
    document.documentElement.addEventListener('mousemove', this.move);
    document.documentElement.addEventListener('mouseup', this.up);
    document.documentElement.addEventListener('mouseleave', this.up);
    document.documentElement.addEventListener('mousedown', this.deselect);
    document.documentElement.addEventListener('touchmove', this.move, true);
    document.documentElement.addEventListener('touchend touchcancel', this.up, true);
    document.documentElement.addEventListener('touchstart', this.up, true);
    this.getCenter();
    if (this.dragHandle) {
      var dragHandles = Array.prototype.slice.call(this.$el.querySelectorAll(this.dragHandle));
      for (var i in dragHandles) {
        dragHandles[i].setAttribute('data-drag-handle', this._uid);
      }
    }
    if (this.dragCancel) {
      var cancelHandles = Array.prototype.slice.call(this.$el.querySelectorAll(this.dragCancel));
      for (var _i in cancelHandles) {
        cancelHandles[_i].setAttribute('data-drag-cancel', this._uid);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.documentElement.removeEventListener('mousemove', this.move);
    document.documentElement.removeEventListener('mouseup', this.up);
    document.documentElement.removeEventListener('mouseleave', this.up);
    document.documentElement.removeEventListener('mousedown', this.deselect);
    document.documentElement.removeEventListener('touchmove', this.move, true);
    document.documentElement.removeEventListener('touchend touchcancel', this.up, true);
    document.documentElement.removeEventListener('touchstart', this.up, true);
  },
  methods: {
    debounce: function debounce(method, context, params) {
      clearTimeout(method.timeout);
      method.timeout = setTimeout(function () {
        method.call(context, params);
      }, 300);
    },
    getCenter: function getCenter() {
      var el = this.$refs.current;
      this.rotateCenter = [el.getBoundingClientRect().left + el.getBoundingClientRect().width / 2, el.getBoundingClientRect().top + el.getBoundingClientRect().height / 2];
    },
    cacuFather: function cacuFather() {
      this.parentElement = this.$el.parentNode;
      this.parentWidth = this.parentW ? this.parentW : this.parentElement.clientWidth;
      this.parentHeight = this.parentH ? this.parentH : this.parentElement.clientHeight;
      this.rawRight = this.parentWidth - this.rawWidth - this.rawLeft;
      this.rawBottom = this.parentHeight - this.rawHeight - this.rawTop;
    },
    deselect: function deselect() {
      if (this.preventActiveBehavior) {
        return;
      }
      this.active = false;
    },
    move: function move(ev) {
      if (!this.stickDrag && !this.bodyDrag && !this.rotateDrag) {
        return;
      }
      ev.stopPropagation();
      if (this.stickDrag) {
        this.stickMove(ev);
      }
      if (this.bodyDrag) {
        this.bodyMove(ev);
      }
      if (this.rotateDrag) {
        this.rotateMove(ev);
      }
    },
    up: function up(ev) {
      if (this.stickDrag) {
        this.stickUp(ev);
      }
      if (this.bodyDrag) {
        this.bodyUp(ev);
      }
      if (this.rotateDrag) {
        this.rotateUp(ev);
      }
    },

    bodyDown: function bodyDown(ev) {
      var target = ev.target || ev.srcElement;
      if (!this.preventActiveBehavior) {
        this.active = true;
      }
      if (ev.button && ev.button !== 0) {
        return;
      }
      this.$emit('clicked', ev);
      if (!this.isDraggable || !this.active) {
        return;
      }
      if (this.dragHandle && target.getAttribute('data-drag-handle') !== this._uid.toString()) {
        return;
      }
      if (this.dragCancel && target.getAttribute('data-drag-cancel') === this._uid.toString()) {
        return;
      }
      this.bodyDrag = true;
      this.stickStartPos.mouseX = ev.pageX || ev.touches[0].pageX;
      this.stickStartPos.mouseY = ev.pageY || ev.touches[0].pageY;
      this.stickStartPos.left = this.left;
      this.stickStartPos.right = this.right;
      this.stickStartPos.top = this.top;
      this.stickStartPos.bottom = this.bottom;
      if (this.parentLimitation) {
        this.limits = this.calcDragLimitation();
      }
    },
    calcDragLimitation: function calcDragLimitation() {
      var parentWidth = this.parentWidth;
      var parentHeight = this.parentHeight;
      return {
        minLeft: 0,
        maxLeft: parentWidth - this.width,
        minRight: 0,
        maxRight: parentWidth - this.width,
        minTop: 0,
        maxTop: parentHeight - this.height,
        minBottom: 0,
        maxBottom: parentHeight - this.height
      };
    },
    bodyMove: function bodyMove(ev) {
      var stickStartPos = this.stickStartPos;
      var delta = {
        x: (this.axis !== 'y' && this.axis !== 'none' ? stickStartPos.mouseX - (ev.pageX || ev.touches[0].pageX) : 0) / this.parentScaleX,
        y: (this.axis !== 'x' && this.axis !== 'none' ? stickStartPos.mouseY - (ev.pageY || ev.touches[0].pageY) : 0) / this.parentScaleY
      };
      this.rawTop = stickStartPos.top - delta.y;
      this.rawBottom = stickStartPos.bottom + delta.y;
      this.rawLeft = stickStartPos.left - delta.x;
      this.rawRight = stickStartPos.right + delta.x;
      if (this.snapToGrid) {
        var alignTop = true;
        var alignLeft = true;

        var diffT = this.rawTop - Math.floor(this.rawTop / this.gridY) * this.gridY;
        var diffB = this.parentHeight - this.rawBottom - Math.floor((this.parentHeight - this.rawBottom) / this.gridY) * this.gridY;
        var diffL = this.rawLeft - Math.floor(this.rawLeft / this.gridX) * this.gridX;
        var diffR = this.parentWidth - this.rawRight - Math.floor((this.parentWidth - this.rawRight) / this.gridX) * this.gridX;

        if (diffT > this.gridY / 2) {
          diffT -= this.gridY;
        }
        if (diffB > this.gridY / 2) {
          diffB -= this.gridY;
        }
        if (diffL > this.gridX / 2) {
          diffL -= this.gridX;
        }
        if (diffR > this.gridX / 2) {
          diffR -= this.gridX;
        }

        if (Math.abs(diffB) < Math.abs(diffT)) {
          alignTop = false;
        }
        if (Math.abs(diffR) < Math.abs(diffL)) {
          alignLeft = false;
        }

        this.rawTop -= alignTop ? diffT : diffB;
        this.rawBottom = this.parentHeight - this.height - this.rawTop;
        this.rawLeft -= alignLeft ? diffL : diffR;
        this.rawRight = this.parentWidth - this.width - this.rawLeft;
      }

      this.$emit('dragging', this.rect);
    },
    bodyUp: function bodyUp() {
      this.bodyDrag = false;
      this.$emit('dragging', this.rect);
      this.$emit('dragstop', this.rect);
      this.stickStartPos = { mouseX: 0, mouseY: 0, x: 0, y: 0, w: 0, h: 0 };
      this.limits = {
        minLeft: null,
        maxLeft: null,
        minRight: null,
        maxRight: null,
        minTop: null,
        maxTop: null,
        minBottom: null,
        maxBottom: null
      };
    },

    rotateDown: function rotateDown(ev) {
      if (!this.isRotatable || !this.active) {
        return;
      }
      this.getCenter();
      this.rotateDrag = true;
      this.rotateStart = [ev.clientX || ev.touches[0].pageX, ev.clientY || ev.touches[0].pageY];
    },
    rotateMove: function rotateMove(event) {
      var el = this.$refs.current;
      var a = this.calculLength(this.rotateStart[0], event.clientX || event.touches[0].pageX, this.rotateStart[1], event.clientY || event.touches[0].pageY);
      var c = this.calculLength(this.rotateStart[0], this.rotateCenter[0], this.rotateStart[1], this.rotateCenter[1]);
      var b = this.calculLength(this.rotateCenter[0], event.clientX || event.touches[0].pageX, this.rotateCenter[1], event.clientY || event.touches[0].pageY);
      var direct = this.calculClock(this.rotateCenter[0], this.rotateCenter[1], this.rotateStart[0], this.rotateStart[1], event.clientX || event.touches[0].pageX, event.clientY || event.touches[0].pageY) >= 0;
      var rawDeg = this.calculrawDegA(a, b, c);
      rawDeg = Math.abs(rawDeg);
      //determine clockwise
      if (!direct) {
        rawDeg = 0 - rawDeg;
      }
      var srawDeg = this.rawDeg;
      srawDeg += rawDeg;
      Math.abs(srawDeg) > 360 ? srawDeg %= 360 : true;
      this.rawDeg = srawDeg;
      this.rotateStart[0] = event.clientX || event.touches[0].pageX;
      this.rotateStart[1] = event.clientY || event.touches[0].pageY;
      this.$emit('rotating', this.rawDeg);
    },
    rotateUp: function rotateUp() {
      this.rotateDrag = false;
      this.$emit('rotating', this.rawDeg);
      this.$emit('rotatestop', this.rawDeg);
    },

    stickDown: function stickDown(stick, ev) {
      if (!this.isResizable || !this.active) {
        return;
      }
      this.stickDrag = true;
      //means now is vue3
      if (this.$refs.bl[0] === undefined) {
        this.currentFixArray = [this.$refs.bl.getBoundingClientRect().x, this.$refs.bl.getBoundingClientRect().y];
      } else {
        // means now is vue2
        this.currentFixArray = [this.$refs.bl[0].getBoundingClientRect().x, this.$refs.bl[0].getBoundingClientRect().y];
      }
      switch (stick) {
        case 'tl':
          this.$refs.current.style.transformOrigin = 'bottom right';
          break;
        case 'tm':
          this.$refs.current.style.transformOrigin = 'bottom center';
          break;
        case 'tr':
          this.$refs.current.style.transformOrigin = 'bottom left';
          break;
        case 'mr':
          this.$refs.current.style.transformOrigin = 'left center';
          break;
        case 'br':
          this.$refs.current.style.transformOrigin = 'top left';
          break;
        case 'bm':
          this.$refs.current.style.transformOrigin = 'top center';
          break;
        case 'bl':
          this.$refs.current.style.transformOrigin = 'top right';
          break;
        case 'ml':
          this.$refs.current.style.transformOrigin = 'right center';
          break;
      }
      // eslint-disable-next-line prettier/prettier
      if (this.$refs.bl[0] === undefined) {
        this.finalFixArray = [this.currentFixArray[0] - this.$refs.bl.getBoundingClientRect().x, this.currentFixArray[1] - this.$refs.bl.getBoundingClientRect().y];
      } else {
        this.finalFixArray = [this.currentFixArray[0] - this.$refs.bl[0].getBoundingClientRect().x, this.currentFixArray[1] - this.$refs.bl[0].getBoundingClientRect().y];
      }
      this.left = this.left + this.finalFixArray[0] / this.parentScaleX;
      this.right = this.right - this.finalFixArray[0] / this.parentScaleX;
      this.top = this.top + this.finalFixArray[1] / this.parentScaleY;
      this.bottom = this.bottom - this.finalFixArray[1] / this.parentScaleY;
      this.stickStartPos.mouseX = ev.pageX || ev.touches[0].pageX;
      this.stickStartPos.mouseY = ev.pageY || ev.touches[0].pageY;
      this.stickStartPos.left = this.left;
      this.stickStartPos.right = this.right;
      this.stickStartPos.top = this.top;
      this.stickStartPos.bottom = this.bottom;
      this.currentStick = stick.split('');
      this.ratioStick = stick;
      this.stickAxis = null;
      switch (this.currentStick[0]) {
        case 'b':
          this.stickAxis = 'y';
          break;
        case 't':
          this.stickAxis = 'y';
          break;
      }
      switch (this.currentStick[1]) {
        case 'r':
          this.stickAxis = this.stickAxis === 'y' ? 'xy' : 'x';
          break;
        case 'l':
          this.stickAxis = this.stickAxis === 'y' ? 'xy' : 'x';
          break;
      }
      this.limits = this.calcResizeLimitation();
    },
    calcResizeLimitation: function calcResizeLimitation() {
      var minw = this.minWidth;
      var minh = this.minHeight;
      var aspectFactor = this.aspectFactor;
      var width = this.width;
      var height = this.height;
      var bottom = this.bottom;
      var top = this.top;
      var left = this.left;
      var right = this.right;
      var stickAxis = this.stickAxis;
      var parentLim = this.parentLimitation ? 0 : null;
      if (this.aspectRatio) {
        if (minw / minh > aspectFactor) {
          minh = minw / aspectFactor;
        } else {
          minw = aspectFactor * minh;
        }
      }
      var limits = {
        minLeft: parentLim,
        maxLeft: left + (width - minw),
        minRight: parentLim,
        maxRight: right + (width - minw),
        minTop: parentLim,
        maxTop: top + (height - minh),
        minBottom: parentLim,
        maxBottom: bottom + (height - minh)
      };
      if (this.aspectRatio) {
        var aspectLimits = {
          minLeft: left - Math.min(top, bottom) * aspectFactor * 2,
          maxLeft: left + (height - minh) / 2 * aspectFactor * 2,
          minRight: right - Math.min(top, bottom) * aspectFactor * 2,
          maxRight: right + (height - minh) / 2 * aspectFactor * 2,
          minTop: top - Math.min(left, right) / aspectFactor * 2,
          maxTop: top + (width - minw) / 2 / aspectFactor * 2,
          minBottom: bottom - Math.min(left, right) / aspectFactor * 2,
          maxBottom: bottom + (width - minw) / 2 / aspectFactor * 2
        };
        if (stickAxis === 'x') {
          limits = {
            minLeft: Math.max(limits.minLeft, aspectLimits.minLeft),
            maxLeft: Math.min(limits.maxLeft, aspectLimits.maxLeft),
            minRight: Math.max(limits.minRight, aspectLimits.minRight),
            maxRight: Math.min(limits.maxRight, aspectLimits.maxRight)
          };
        } else if (stickAxis === 'y') {
          limits = {
            minTop: Math.max(limits.minTop, aspectLimits.minTop),
            maxTop: Math.min(limits.maxTop, aspectLimits.maxTop),
            minBottom: Math.max(limits.minBottom, aspectLimits.minBottom),
            maxBottom: Math.min(limits.maxBottom, aspectLimits.maxBottom)
          };
        }
      }
      return limits;
    },
    stickMove: function stickMove(ev) {
      if ((ev.pageX || ev.touches != undefined) && (ev.pageY || ev.touches != undefined)) {
        var stickStartPos = this.stickStartPos;
        var delta = {
          x: (stickStartPos.mouseX - (ev.pageX || ev.touches[0].pageX)) / this.parentScaleX,
          y: (stickStartPos.mouseY - (ev.pageY || ev.touches[0].pageY)) / this.parentScaleY
        };
        var tempDeltaX = Math.cos(-this.deg * Math.PI / 180) * delta.x - Math.sin(-this.deg * Math.PI / 180) * delta.y;
        var tempDeltaY = Math.sin(-this.deg * Math.PI / 180) * delta.x + Math.cos(-this.deg * Math.PI / 180) * delta.y;
        delta.x = tempDeltaX;
        delta.y = tempDeltaY;
        switch (this.currentStick[0]) {
          case 'b':
            this.rawBottom = stickStartPos.bottom + delta.y;
            break;
          case 't':
            this.rawTop = stickStartPos.top - delta.y;
            break;
        }
        switch (this.currentStick[1]) {
          case 'r':
            this.rawRight = stickStartPos.right + delta.x;
            break;
          case 'l':
            this.rawLeft = stickStartPos.left - delta.x;
            break;
        }
        this.$emit('resizing', this.rect);
      }
    },
    stickUp: function stickUp() {
      this.stickDrag = false;
      this.stickStartPos = {
        mouseX: 0,
        mouseY: 0,
        x: 0,
        y: 0,
        w: 0,
        h: 0
      };
      this.limits = {
        minLeft: null,
        maxLeft: null,
        minRight: null,
        maxRight: null,
        minTop: null,
        maxTop: null,
        minBottom: null,
        maxBottom: null
      };
      if (this.$refs.bl[0] === undefined) {
        this.currentFixArray = [this.$refs.bl.getBoundingClientRect().x, this.$refs.bl.getBoundingClientRect().y];
        this.$refs.current.style.transformOrigin = 'center center';
        this.finalFixArray = [this.currentFixArray[0] - this.$refs.bl.getBoundingClientRect().x, this.currentFixArray[1] - this.$refs.bl.getBoundingClientRect().y];
      } else {
        this.currentFixArray = [this.$refs.bl[0].getBoundingClientRect().x, this.$refs.bl[0].getBoundingClientRect().y];
        this.$refs.current.style.transformOrigin = 'center center';
        this.finalFixArray = [this.currentFixArray[0] - this.$refs.bl[0].getBoundingClientRect().x, this.currentFixArray[1] - this.$refs.bl[0].getBoundingClientRect().y];
      }
      this.left = this.left + this.finalFixArray[0] / this.parentScaleX;
      this.right = this.right - this.finalFixArray[0] / this.parentScaleX;
      this.top = this.top + this.finalFixArray[1] / this.parentScaleY;
      this.bottom = this.bottom - this.finalFixArray[1] / this.parentScaleY;
      this.stickAxis = null;
      this.$emit('resizing', this.rect);
      this.$emit('resizestop', this.rect);
    },
    aspectRatioCorrection: function aspectRatioCorrection() {
      if (!this.aspectRatioStickFlag) {
        return;
      }
      var bottom = this.bottom;
      var top = this.top;
      var left = this.left;
      var right = this.right;
      var width = this.width;
      var height = this.height;
      var aspectFactor = this.aspectFactor;
      var currentStick = this.currentStick;
      if (width / height > aspectFactor) {
        var newWidth = aspectFactor * height;
        if (currentStick[1] === 'l') {
          this.left = left + width - newWidth;
        } else {
          this.right = right + width - newWidth;
        }
      } else {
        var newHeight = width / aspectFactor;
        if (currentStick[0] === 't') {
          this.top = top + height - newHeight;
        } else {
          this.bottom = bottom + height - newHeight;
        }
      }
    },

    //朴素的两点间距离公式
    calculLength: function calculLength(x1, x2, y1, y2) {
      return Math.hypot(x1 - x2, y1 - y2);
    },

    //余弦定理求角度
    calculrawDegA: function calculrawDegA(a, b, c) {
      return Math.acos((b * b + c * c - a * a) / (2 * b * c)) * (180 / Math.PI);
    },

    //六个点坐标，通过矢量叉积获取旋转方向
    calculClock: function calculClock(x1, y1, x2, y2, x3, y3) {
      return (x2 - x1) * (y3 - y1) - (y2 - y1) * (x3 - x1);
    }
  },
  computed: {
    currentHalfWidth: function currentHalfWidth() {
      return {
        'font-size': '30px',
        position: 'absolute',
        top: '-50px',
        cursor: 'pointer',
        left: '50%',
        marginLeft: '-12px',
        color: '#888888'
      };
    },
    style: function style() {
      return {
        top: this.top + 'px',
        left: this.left + 'px',
        width: this.width + 'px',
        height: this.height + 'px',
        zIndex: this.zIndex
      };
    },
    vdrStick: function vdrStick() {
      var _this = this;

      return function (stick) {
        var stickStyle = {
          width: stickSize / _this.parentScaleX + 'px',
          height: stickSize / _this.parentScaleY + 'px'
        };
        stickStyle[styleMapping.y[stick[0]]] = stickSize / _this.parentScaleX / -2 + 'px';
        stickStyle[styleMapping.x[stick[1]]] = stickSize / _this.parentScaleX / -2 + 'px';
        return stickStyle;
      };
    },
    width: function width() {
      return this.parentWidth - this.left - this.right;
    },
    height: function height() {
      return this.parentHeight - this.top - this.bottom;
    },
    rect: function rect() {
      return {
        left: Math.round(this.left),
        top: Math.round(this.top),
        width: Math.round(this.width),
        height: Math.round(this.height)
      };
    },
    aspectRatioStickFlag: function aspectRatioStickFlag() {
      if (this.aspectRatioSticks.indexOf(this.ratioStick) >= 0 && this.aspectRatio) {
        return true;
      }
      return false;
    },
    aspectFactor: function aspectFactor() {
      return this.w / this.h;
    }
  },
  watch: {
    rawLeft: function rawLeft(newLeft) {
      var limits = this.limits;
      var stickAxis = this.stickAxis;
      var aspectFactor = this.aspectFactor;
      var aspectRatio = this.aspectRatio;
      var left = this.left;
      var bottom = this.bottom;
      var top = this.top;
      if (limits.minLeft !== null && newLeft < limits.minLeft) {
        newLeft = limits.minLeft;
      } else if (limits.maxLeft !== null && limits.maxLeft < newLeft) {
        newLeft = limits.maxLeft;
      }
      if (this.aspectRatioStickFlag && stickAxis === 'x') {
        var delta = left - newLeft;
        this.rawTop = top - delta / aspectFactor / 2;
        this.rawBottom = bottom - delta / aspectFactor / 2;
      }
      this.left = newLeft;
    },
    rawRight: function rawRight(newRight) {
      var limits = this.limits;
      var stickAxis = this.stickAxis;
      var aspectFactor = this.aspectFactor;
      var aspectRatio = this.aspectRatio;
      var right = this.right;
      var bottom = this.bottom;
      var top = this.top;
      if (limits.minRight !== null && newRight < limits.minRight) {
        newRight = limits.minRight;
      } else if (limits.maxRight !== null && limits.maxRight < newRight) {
        newRight = limits.maxRight;
      }
      if (this.aspectRatioStickFlag && stickAxis === 'x') {
        var delta = right - newRight;
        this.rawTop = top - delta / aspectFactor / 2;
        this.rawBottom = bottom - delta / aspectFactor / 2;
      }
      this.right = newRight;
    },
    rawTop: function rawTop(newTop) {
      var limits = this.limits;
      var stickAxis = this.stickAxis;
      var aspectFactor = this.aspectFactor;
      var aspectRatio = this.aspectRatio;
      var right = this.right;
      var left = this.left;
      var top = this.top;
      if (limits.minTop !== null && newTop < limits.minTop) {
        newTop = limits.minTop;
      } else if (limits.maxTop !== null && limits.maxTop < newTop) {
        newTop = limits.maxTop;
      }
      if (this.aspectRatioStickFlag && stickAxis === 'y') {
        var delta = top - newTop;
        this.rawLeft = left - delta * aspectFactor / 2;
        this.rawRight = right - delta * aspectFactor / 2;
      }
      this.top = newTop;
    },
    rawBottom: function rawBottom(newBottom) {
      var limits = this.limits;
      var stickAxis = this.stickAxis;
      var aspectFactor = this.aspectFactor;
      var aspectRatio = this.aspectRatio;
      var right = this.right;
      var left = this.left;
      var bottom = this.bottom;
      if (limits.minBottom !== null && newBottom < limits.minBottom) {
        newBottom = limits.minBottom;
      } else if (limits.maxBottom !== null && limits.maxBottom < newBottom) {
        newBottom = limits.maxBottom;
      }
      if (this.aspectRatioStickFlag && stickAxis === 'y') {
        var delta = bottom - newBottom;
        this.rawLeft = left - delta * aspectFactor / 2;
        this.rawRight = right - delta * aspectFactor / 2;
      }
      this.bottom = newBottom;
    },
    width: function width() {
      this.aspectRatioCorrection();
    },
    height: function height() {
      this.aspectRatioCorrection();
    },
    active: function active(isActive) {
      if (isActive) {
        this.$emit('activated');
      } else {
        this.$emit('deactivated');
      }
    },
    isActive: function isActive(val) {
      this.active = val;
    },
    z: function z(val) {
      if (val >= 0 || val === 'auto') {
        this.zIndex = val;
      }
    },
    minw: function minw(val) {
      if (val > 0 && val <= this.width) {
        this.minWidth = val;
      }
    },
    minh: function minh(val) {
      if (val > 0 && val <= this.height) {
        this.minHeight = val;
      }
    },
    x: function x() {
      if (this.stickDrag || this.bodyDrag) {
        return;
      }
      if (this.parentLimitation) {
        this.limits = this.calcDragLimitation();
      }
      var delta = this.x - this.left;
      this.rawLeft = this.x;
      this.rawRight = this.right - delta;
    },
    y: function y() {
      if (this.stickDrag || this.bodyDrag) {
        return;
      }
      if (this.parentLimitation) {
        this.limits = this.calcDragLimitation();
      }
      var delta = this.y - this.top;
      this.rawTop = this.y;
      this.rawBottom = this.bottom - delta;
    },
    w: function w() {
      if (this.stickDrag || this.bodyDrag) {
        return;
      }
      this.currentStick = ['m', 'r'];
      this.stickAxis = 'x';
      if (this.parentLimitation) {
        this.limits = this.calcResizeLimitation();
      }
      var delta = this.width - this.w;
      this.rawRight = this.right + delta;
    },
    h: function h() {
      if (this.stickDrag || this.bodyDrag) {
        return;
      }
      this.currentStick = ['b', 'm'];
      this.stickAxis = 'y';
      if (this.parentLimitation) {
        this.limits = this.calcResizeLimitation();
      }
      var delta = this.height - this.h;
      this.rawBottom = this.bottom + delta;
    },
    parentW: function parentW(val) {
      this.right = val - this.width - this.left;
      this.parentWidth = val;
    },
    parentH: function parentH(val) {
      this.bottom = val - this.height - this.top;
      this.parentHeight = val;
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "iconfont.eot?dec562c54fd65441e9f83c9298d4b6de";

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_vueDragResizeRotate_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_iconfont_iconfont_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_iconfont_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_iconfont_iconfont_css__);


__WEBPACK_IMPORTED_MODULE_0__lib_vueDragResizeRotate_vue__["a" /* default */].install = function (Vue) {
  return Vue.component(__WEBPACK_IMPORTED_MODULE_0__lib_vueDragResizeRotate_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__lib_vueDragResizeRotate_vue__["a" /* default */]);
};
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__lib_vueDragResizeRotate_vue__["a" /* default */]);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vueDragResizeRotate_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6ecc2c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vueDragResizeRotate_vue__ = __webpack_require__(10);
function injectStyle (ssrContext) {
  __webpack_require__(6)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vueDragResizeRotate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6ecc2c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vueDragResizeRotate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(7);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("55957b73", content, true, {});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".vdr{box-sizing:border-box}.vdr,span.rotate{position:absolute}span.rotate{font-size:20px;top:-30px;cursor:pointer;right:-30px;color:#000}.vdr-stick{box-sizing:border-box;position:absolute;font-size:1px;background:#fff;border:1px solid #6c6c6c;box-shadow:0 0 2px #bbb}.inactive .vdr-stick{display:none}.vdr-stick-br,.vdr-stick-tl{cursor:nwse-resize}.vdr-stick-bm,.vdr-stick-tm{left:50%;cursor:ns-resize}.vdr-stick-bl,.vdr-stick-tr{cursor:nesw-resize}.vdr-stick-ml,.vdr-stick-mr{top:50%;cursor:ew-resize}.vdr-stick.not-resizable{display:none}.vdr.active:before{cursor:move}", ""]);

// exports


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"current",staticClass:"vdr",class:_vm.active || _vm.isActive ? 'active' : 'inactive',style:(Object.assign({}, _vm.style, {transform: 'rotateZ(' + _vm.deg + 'Deg)'})),attrs:{"tabIndex":"-1"},on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();return _vm.bodyDown($event)},"touchstart":function($event){$event.stopPropagation();$event.preventDefault();return _vm.bodyDown($event)}}},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.sticks),function(stick,key){return _c('div',{key:key,ref:stick,refInFor:true,staticClass:"vdr-stick",class:['vdr-stick-' + stick, _vm.isResizable ? '' : 'not-resizable'],style:(_vm.vdrStick(stick)),on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();return _vm.stickDown(stick, $event)},"touchstart":function($event){$event.stopPropagation();$event.preventDefault();return _vm.stickDown(stick, $event)}}})}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRotatable && _vm.active),expression:"isRotatable && active"}],staticClass:"iconfont icon-rotate",style:(_vm.currentHalfWidth),on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();return _vm.rotateDown($event)},"touchstart":function($event){$event.stopPropagation();$event.preventDefault();return _vm.rotateDown($event)}}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(12);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0b6cd7e8", content, true, {});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(13);
exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "@font-face{font-family:iconfont;src:url(" + escape(__webpack_require__(3)) + ");src:url(" + escape(__webpack_require__(3)) + "#iefix) format(\"embedded-opentype\"),url(\"data:application/x-font-woff2;charset=utf-8;base64,d09GMgABAAAAAAL4AAsAAAAABqQAAAKsAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHEIGVgCCcAqBMIE8ATYCJAMICwYABCAFhG0HMBviBcgekiSQECIE66AcALAQwff7sd9z30U1qTeG6lm0kSyRKE0sEhKdkCiFSDb7kt+f/tU7QF268+pE5u86O9mcOkgV0QHqhKK7vAGPP7ic/gookHlAuc0xcA3AwNJAxxqUUFogAXjD2AUu4TCBWj08aC3HJmeDocwaFYgjqbgCDHNuWWaxaqGyZmEW1/RUp5P0BOAq/H68gygMSSoKVsHaYUw1hD/Z2QlFY9mo2Edw5jOCLaPAFJCJrdrwCh3ByDpqw7oGwL5ygye7svS1Yq9/nqhkZdeDLsi+J47LvdXsBHLcPQusjbqMNF1T9/aW/fKS8/r6/p43c3i96fhS7ttX3rv1Nq85eRPLdmNjdtqjN8amp7fjMw7ZOxdNlz3njWdPJbnJ33oFMbkJrm/2eOmzaYdOHcypsGEpRFbgv+E8u+6x4b3o7LGFlNMzP2EP1pPT03Nsh136jQzrf8xybc1uVC79FPymHu8Oh3CA8rhYLyL/5W/cCfTuyiyC/xvWZfAYs6cXOsvjDP2soPqMluDPcXo2ZZ1naVJWObXWZHbUyIRatSgB21v9jS26zXio1nGz1irdKRSqDaGZNAUV6sxApWpzUGtS3PI6bSgdkWswoQ1AaLYNSaN7KDR7RjPpFyp0+odKzaEDtXbCZsM6IyE1jqK4guFqVNmApFVExTk6ZhzlZmJxjaKCZnkhJRdTjdSHhDxBMRaHVZjOMUVTKxYxxiGOEiWKBcdhhYIgNSUyXMV4EsbUgXw+V/ciXhVRgrElFFaBwaohlRogUlUIFc7vzBiXPp8JE6uhUIG2lNWYc2GUhrR3RIhH0AONE6t6ld3LMxq1xEQYhoNwKEIJiQVGTGGHCURd308Gq8LwSEYE1QLxUTuur5i3vlT5AVmsCkuRwk4qVB4TdtMqAA==\") format(\"woff2\"),url(" + escape(__webpack_require__(14)) + ") format(\"woff\"),url(" + escape(__webpack_require__(15)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(16)) + "#iconfont) format(\"svg\")}.iconfont{font-family:iconfont!important;font-size:16px;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-rotate:before{content:\"\\E615\"}", ""]);

// exports


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "iconfont.woff?055eb59d253682bf5544443dab9054ea";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "iconfont.ttf?323764f983e0c86be7b5607b4fdaa7cf";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "iconfont.svg?2f95f0701928b8b63e02561dc8d6fa18";

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// vue-drag-resize-rotate.js